import React from 'react';

import { Box, Typography } from '@mui/material';
import ViewWeekOutlinedIcon from '@mui/icons-material/ViewWeekOutlined';

import { useTheme } from 'hooks';

import type { Column } from 'api/shared/models';

import ColumnOptions from '../ColumnOptions';
import { styles } from '../styles';

interface Props {
  columns: Column[];
  showConfigName: boolean;
  onClick: (column: Column) => void;
}

const AvailableColumns = ({ columns, showConfigName, onClick }: Props) => {
  const { palette } = useTheme();

  return (
    <Box style={{ backgroundColor: palette.background.paper }}>
      <Typography variant="h6" sx={styles.headerColumn}>
        <ViewWeekOutlinedIcon style={{ marginRight: 8 }} /> Columnas disponibles
      </Typography>
      <ColumnOptions
        columns={columns}
        showConfigName={showConfigName}
        onClick={onClick}
        addDragAndDrop={false}
      />
    </Box>
  );
};

export default AvailableColumns;
